
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css'
import './clerk-custom.css'
import './i18n/i18n'; // Import i18n configuration
import ClerkProviderWithI18n from './ClerkProviderWithI18n';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ClerkProviderWithI18n>
        <App />
      </ClerkProviderWithI18n>
    </BrowserRouter>
  </React.StrictMode>
);
